import { render, staticRenderFns } from "./ProductsReviewSection.vue?vue&type=template&id=1bb0c93f&scoped=true&"
import script from "./ProductsReviewSection.vue?vue&type=script&lang=js&"
export * from "./ProductsReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductsReviewSection.vue?vue&type=style&index=0&id=1bb0c93f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0c93f",
  null
  
)

export default component.exports